<template>
    <div>
        <main class="main-content">
            <div class="page-content">
                <div class="container">
                    <div class="lds-ring" v-if="!isLoad"><div></div><div></div><div></div><div></div></div>
                    <section class="geo-section geo-section--options" v-if="isLoad">
                    <div class="page-title page-title_ic">
                        <div class="info-title__icon">
                        <svg width="1.8rem" height="2.2rem">
                            <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-tel2"></use>
                        </svg>
                        </div>
                        <h2 class="info-title__heading">Additional Options</h2>
                    </div>
                    <div class="options-add" v-if="mountains.find(item => item.active)">
                        <form action="javascript:void(0)" class="options-add--form">
                        <div class="form-control-group form-control-group_1"><span class="form-control-label">Mount</span>
                            <div :class="['select-wrapper select-wrapper', {'is-active' : mountSelect}]" @click="mountSelect = !mountSelect">
                            <div class="select-trigger"><span class="select-trigger__name">{{mountains.find(item => item.active).title}}</span><span class="select-trigger__icon">
                                <svg width="1em" height="1em" class="icon icon-chevron ">
                                    <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron"></use>
                                </svg></span></div>
                            <div class="select-body">
                                <div class="select-inner js-scrollbar">
                                <div
                                    v-for="item in mountains"
                                    :key="item.id"
                                    :class="['select-option', { 'is-selected': item.active }]"
                                    @click="mountains = mountains.map(mount => ({...mount, active: mount.id === item.id}))"><span class="select-option__name">{{item.title}}</span></div>
                                </div>
                            </div>
                            </div>
                        </div>
                        <div class="form-control-group form-control-group_2"><span class="form-control-label">Title</span>
                            <div :class="['form-control-wrap', { 'is-error' : errors.title}]">
                                <input type="text" Placeholder="Title" class="form-control" @focus="errors.title = false" v-model="name"/>
                            </div>
                        </div>
                        <div class="form-control-group form-control-group_3"><span class="form-control-label">Pax Limit</span>
                            <div :class="['form-control-wrap', { 'is-error' : errors.limit}]">
                            <input type="text" Placeholder="Limit" class="form-control" :style="{paddingRight: '0px'}" @focus="errors.limit = false" v-model="pax"/>
                            </div>
                        </div>
                        <div class="form-control-group form-control-group_6"><span class="form-control-label">Price for guests</span>
                            <div :class="['form-control-wrap form-control-wrap_with-label', { 'is-error' : errors.price}]">
                                <input type="text" Placeholder="Price" class="form-control" @focus="errors.price = false" v-model="price"/>
                            <span class="label-inp">USD</span>
                            </div>
                        </div>
                        <div class="form-control-group form-control-group_6"><span class="form-control-label">Cost price</span>
                          <div :class="['form-control-wrap form-control-wrap_with-label', { 'is-error' : errors.basePrice}]">
                            <input type="text" Placeholder="Price" class="form-control" @focus="errors.basePrice = false" v-model="basePrice"/>
                            <span class="label-inp">USD</span>
                          </div>
                        </div>
                          <div class="price-type__container">
                            <div class="form-control-group--radio">
                              <label for="chk_1125" class="form-control-radio">
                                <input id="chk_1125" type="radio" name="perClimb" :value="true"
                                       v-model="costType"
                                ><span
                                  class="form-control-radio__box"></span><span
                                  class="form-control-radio__name">Cost Per Climb</span>
                              </label>
                              <label for="chk_1126" class="form-control-radio">
                                <input id="chk_1126" type="radio" name="perDay" :value="false"
                                       v-model="costType"
                                ><span
                                  class="form-control-radio__box"></span><span
                                  class="form-control-radio__name">Сost Per Day</span>
                              </label>
                            </div>
                          </div>
                        <div class="form-control-group form-control-group_editor-4">
                            <span class="form-control-label">Description</span>
                            <div class="js-ckeditor">
                                <editor :editor="editor" v-model="desc"  :config="editorConfig"></editor>
                            </div>
                        </div>
                        <div class="btn-edit-form-additional">
                            <button type="submit" class="btn btn--green geo-section__location-form__submit" @click="createAdditionalHandler"> <span>Add</span></button>
                        </div>
                        </form>
                    </div>
                    <div class="geo-section__options">
                        <div class="section-title">
                        <h3>Available Add-ons for Climbing</h3>
                        </div>
                        <div data-simplebar="data-simplebar" class="section-table-wrap">
                        <div class="section-table section-table--geo section-table--edit">
                            <div class="section-table__head">
                            <div class="col col-mount"><span>Mount</span></div>
                            <div class="col col-title-2"><span>Title</span></div>
                            <div class="col col-pax-limit"><span>Pax Limit</span></div>
                            <div class="col col-price-2"><span>Price for guests</span></div>
                            <div class="col col-price-base"><span>Cost price</span></div>
                            </div>
                            <div class="section-table__body">
                            <div class="section-table__row" v-for="(item, index) in additional" :key="item.id">
                                <div class="col col-mount">
                                <div class="section-table__row__number">{{index + 1}}</div>
                                <div class="section-table__row__name">{{item.mountTitle}}</div>
                                </div>
                                <div class="col col-title-2"><span>{{item.title}}</span></div>
                                <div class="col col-pax-limit"><span>{{item.paxLimit}}</span></div>
                                <div class="col col-price-2"><span>${{item.price}}</span></div>
                                <div class="col col-price-base"><span>${{item.base}}</span></div>
                                <div class="col col-actions">
                                <button type="button" class="btn btn--edit" @click="editHandler(item)">
                                    <svg width="1em" height="1em" class="icon icon-edit ">
                                    <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-edit"></use>
                                    </svg>
                                </button>
                                <button type="button" class="btn btn--remove" @click="$emit('deleteModalHandler', {
                                            entity: 'Additional Option',
                                            name: item.title,
                                            handler: deleteAdditionalHandler,
                                            id: item.id
                                        })">
                                    <svg width="1em" height="1em" class="icon icon-close ">
                                    <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-close"></use>
                                    </svg>
                                </button>
                                </div>
                                <div class="col col-description" v-if="item.description"><div v-html="item.description"></div></div>
                            </div>
                            </div>
                        </div>
                        </div>

                    </div>
                    </section>
                </div>
                </div>
        </main>
        <div class="modal-wrapper" v-if="edit">
            <div class="modal-backdrop"></div>
            <div class="modal-inner">
                <div class="edit-popup edit-popup--additional-option">
                <div class="edit-popup__header">

                  <div class="edit-popup__title">
                    <div class="edit-popup__title__icon">
                      <svg width="1em" height="1em" class="icon icon-edit ">
                        <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-edit"></use>
                      </svg>
                    </div><span>Edit additional option</span>
                  </div>
                  <div class="edit-popup__close" @click="isEditFlag ? $emit('notLeavePopupHandler', {
                            handler: clearEdit
                        }) : edit = null">
                    <svg width="1em" height="1em" class="icon icon-close ">
                      <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-close"></use>
                    </svg>
                  </div>
                </div>
              <div class="options-add">
                <form action="javascript:void(0)" class="options-add--form">
                  <div class="form-control-group form-control-group_1"><span class="form-control-label">Mount</span>
                    <div :class="['select-wrapper select-wrapper', {'is-active' : mountEditSelect}]" @click="mountEditSelect = !mountEditSelect">
                        <div class="select-trigger"><span class="select-trigger__name">{{mountainsEdit.find(item => item.active).title}}</span><span class="select-trigger__icon">
                            <svg width="1em" height="1em" class="icon icon-chevron ">
                                <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron"></use>
                            </svg></span></div>
                        <div class="select-body">
                            <div class="select-inner js-scrollbar">
                            <div
                                v-for="item in mountainsEdit"
                                :key="item.id"
                                :class="['select-option', { 'is-selected': item.active }]"
                                @click="mountainsEdit = mountainsEdit.map(mount => ({...mount, active: mount.id === item.id}));isEditFlag = true"><span class="select-option__name">{{item.title}}</span></div>
                            </div>
                        </div>
                    </div>
                  </div>
                  <div class="form-control-group form-control-group_2"><span class="form-control-label">Title</span>
                    <div :class="['form-control-wrap', { 'is-error' : errorsEdit.title}]">
                      <input type="text" Placeholder="Title" @change="isEditFlag = true" class="form-control" @focus="errorsEdit.title = false" v-model="nameEdit"/>
                    </div>
                  </div>
                  <div class="form-control-group form-control-group_3"><span class="form-control-label">Pax Limit</span>
                    <div :class="['form-control-wrap', { 'is-error' : errorsEdit.limit}]">
                      <input type="text" Placeholder="Limit" @change="isEditFlag = true" :style="{paddingRight: '0px'}" @focus="errorsEdit.limit = false" class="form-control" v-model="paxEdit"/>
                    </div>
                  </div>
                  <div class="form-control-group form-control-group_4"><span class="form-control-label">Price for guests</span>
                    <div :class="['form-control-wrap form-control-wrap_with-label', { 'is-error' : errorsEdit.price}]">
                      <input type="text" Placeholder="Price" @change="isEditFlag = true" class="form-control" @focus="errorsEdit.price = false" v-model="priceEdit"/>
                      <span class="label-inp">USD</span>
                    </div>
                  </div>
                  <div class="form-control-group form-control-group_4"><span class="form-control-label">Cost price</span>
                    <div :class="['form-control-wrap form-control-wrap_with-label', { 'is-error' : errorsEdit.basePrice}]">
                      <input type="text" Placeholder="Price" @change="isEditFlag = true" class="form-control" @focus="errorsEdit.basePrice = false" v-model="basePriceEdit"/>
                      <span class="label-inp">USD</span>
                    </div>
                  </div>
                  <div class="price-type__container">
                    <div class="form-control-group--radio">
                      <label for="cTE1" class="form-control-radio">
                        <input id="cTE1" type="radio" name="perClimb" :value="true"
                               v-model="costTypeEdit"
                        ><span
                          class="form-control-radio__box"></span><span
                          class="form-control-radio__name">Cost Per Climb</span>
                      </label>
                      <label for="cTE2" class="form-control-radio">
                        <input id="cTE2" type="radio" name="perDay" :value="false"
                               v-model="costTypeEdit"
                        ><span
                          class="form-control-radio__box"></span><span
                          class="form-control-radio__name">Сost Per Day</span>
                      </label>
                    </div>
                  </div>
                  <div class="form-control-group form-control-group_editor-4">
                    <span class="form-control-label">Description</span>
                    <div class="js-ckeditor">
                        <editor :editor="editor" v-model="descEdit"  :config="editorConfig"></editor>
                    </div>
                  </div>
                  <button type="submit" class="btn btn--green geo-section__location-form__submit" @click="updateAdditionalHandler"> <span>Save</span></button>
                </form>
              </div>
              </div>
            </div>
        </div>
    </div>
</template>

<script>

    import {
        getMountains,
        getAdditionals,
        createAdditional,
        deleteAdditional,
        updateAdditional
    } from '@/utilites/api'

    import CKEditor from '@ckeditor/ckeditor5-vue2'
    import ClassicEditor from '@/utilites/ckeditor'

    export default {
        data(){
            return {
                mountains: [],
                mountainsEdit: [],
                mountSelect: false,
                mountEditSelect: false,
                editor: ClassicEditor,
                editorConfig: {
                    placeholder: 'Write description'
                },
                name: '',
                nameEdit: '',
                pax: '',
                desc: '',
                descEdit: '',
                paxEdit: '',
                price: '',
                costType: true,
                costTypeEdit: true,
                basePrice: '',
                priceEdit: '',
                basePriceEdit: '',
                idEdit :'',
                mountTitleEdit: '',
                edit: false,
                isLoad: false,
                isEditFlag: false,
                errors: {
                    title: false,
                    limit: false,
                    price: false
                },
                errorsEdit: {
                    title: false,
                    limit: false,
                    price: false
                }
            }
        },
        props: ['user'],
        components: {editor: CKEditor.component,},
        beforeCreate(){
            document.title = 'Climbing / Additional options'
        },
        mounted(){
            document.title = 'Climbing / Additional options'
            this.updateData()
            getMountains(this.user.access_token)
            .then(res => {
                this.mountains = res.map((item, index) => ({...item, active: index === 0}))
                this.mountainsEdit = res.map((item, index) => ({...item, active: index === 0}))
            })
            window.addEventListener('click', event => {
				if(!event.target.closest('.edit-popup') && !event.target.closest('.btn')){
                    if(this.isEditFlag){
						this.$emit('notLeavePopupHandler', {
							handler: this.clearEdit
						})
					} else {
						this.edit = false
					}
				}
                if(!event.target.closest('.select-wrapper')){
                    this.mountSelect = false
                    this.mountEditSelect = false
                }
            })
        },
        methods: {
            checkErrors(){
				this.errors = {
                    title: /[^A-Za-z0-9\- ]/g.test(this.name.trim()) || this.name.trim().length === 0,
                    limit: /[^0-9]/g.test(this.pax.trim()) || this.pax.trim().length === 0,
                    price: /[^0-9]/g.test(this.price.trim()) || this.price.trim().length === 0,
                    basePrice: /[^0-9]/g.test(this.basePrice.trim()) || this.basePrice.trim().length === 0,
                }
                let error = false
                for (const key in this.errors) {
                    if(this.errors[key]){
                        error = true
                    }
                }
                return error
			},
            checkErrorsEdit(){
				this.errorsEdit = {
                    title: /[^A-Za-z0-9\- ]/g.test(this.nameEdit.trim()) || this.nameEdit.trim().length === 0,
                    limit: /[^0-9]/g.test(this.paxEdit.toString().trim()) || this.paxEdit.toString().trim().length === 0,
                    price: /[^0-9]/g.test(this.priceEdit.toString().trim()) || this.priceEdit.toString().trim().length === 0,
                    basePrice: /[^0-9]/g.test(this.basePriceEdit.toString().trim()) || this.basePriceEdit.toString().trim().length === 0,
                }
                let error = false
                for (const key in this.errorsEdit) {
                    if(this.errorsEdit[key]){
                        error = true
                    }
                }
                return error
			},
            updateData(){
                this.isLoad = false
                getAdditionals(this.user.access_token)
                .then(res => {
                    this.additional = res
                    this.isLoad = true
                })
            },
            createAdditionalHandler(){
                if(!this.checkErrors()){
                     createAdditional(this.user.access_token, {
                        mountId: this.mountains.find(item => item.active).id,
                        title: this.name,
                        paxLimit: this.pax,
                        price: this.price,
                        base: this.basePrice,
                        description: this.desc,
                        costType: this.costType ? 'PER_CLIMB' : 'PER_DAY',
                    })
                    .then(res => {
                        this.name = ''
                        this.pax = ''
                        this.price = ''
                        this.basePrice = ''
                        this.desc = ''
                        this.costType = true
                        this.updateData()
                        this.$emit('confirmed')
                    })
                }
            },
            editHandler(item){
                this.edit = true
                this.nameEdit = item.title
                this.paxEdit = item.paxLimit
                this.priceEdit = item.price
                this.basePriceEdit = item.base
                this.mountTitleEdit = item.mountTitle
                this.descEdit = item.description
                this.idEdit = item.id
                this.costTypeEdit = item.costType === 'PER_CLIMB';
                this.errorsEdit = {
                    title: false,
                    limit: false,
                    price: false,
                    basePrice: false
                }
            },
            updateAdditionalHandler(){
                if(!this.checkErrorsEdit()){
                    updateAdditional(this.user.access_token, {
                        id: this.idEdit,
                        mountId: this.mountainsEdit.find(item => item.active).id,
                        title: this.nameEdit,
                        paxLimit: this.paxEdit,
                        price: this.priceEdit,
                        base: this.basePriceEdit,
                        description: this.descEdit,
                        costType: this.costTypeEdit ? 'PER_CLIMB' : 'PER_DAY',
                    }).then(res => {
                        this.edit = null
                        this.updateData()
                        this.$emit('confirmed')
                    })
                }
            },
            deleteAdditionalHandler(id){
                deleteAdditional(this.user.access_token, id)
                .then(res => {
                    this.updateData()
                    this.$emit('confirmed')
                })
            },
            clearEdit(){
				this.edit = null
				this.isEditFlag = false
			}
        },
        watch: {
            edit(){
                if(this.edit){
                    this.mountainsEdit = this.mountainsEdit.map(item => ({...item, active: item.title === this.mountTitleEdit}))
                }
            }
        }
    }
</script>
<style scoped lang="scss">
.price-type__container {
    display: flex;
    width: 100%;
    margin: 10px 5px 20px 5px;

  & label span {
    font-size: 13px;
  }
}
</style>